<div class="pro-dashboard animate-fade-in">

  <!--  Header  -->
  <div class="pro-header stagger-1">
    <div class="pro-header__text">
      <h1>Panel del profesional</h1>
      <p>{{ auth.currentUserSnapshot?.name }} · {{ auth.currentUserSnapshot?.specialty }}</p>
    </div>
    <button class="logout-btn" (click)="logout()">
      <span class="material-symbols-outlined">logout</span>
      Cerrar sesi�n
    </button>
  </div>

  <!--  Stats strip  -->
  <div class="stats-strip stagger-2">
    <div class="stat-card">
      <span class="material-symbols-outlined stat-icon">hourglass_top</span>
      <div>
        <span class="stat-value">{{ pendingCount }}</span>
        <span class="stat-label">Pendientes</span>
      </div>
    </div>
    <div class="stat-card">
      <span class="material-symbols-outlined stat-icon stat-icon--confirmed">verified</span>
      <div>
        <span class="stat-value">{{ confirmedTodayCount }}</span>
        <span class="stat-label">Confirmados hoy</span>
      </div>
    </div>
    <div class="stat-card">
      <span class="material-symbols-outlined stat-icon stat-icon--total">calendar_month</span>
      <div>
        <span class="stat-value">{{ allAppointments.length }}</span>
        <span class="stat-label">Total turnos</span>
      </div>
    </div>
  </div>

  <!-- Loading skeleton -->
  <div class="skeleton-list" *ngIf="isLoading">
    <div class="skeleton-apt" *ngFor="let i of [1,2,3]">
      <app-skeleton width="60px" height="60px" radius="var(--radius-lg)"></app-skeleton>
      <div class="skeleton-apt__lines">
        <app-skeleton width="180px" height="1rem"></app-skeleton>
        <app-skeleton width="120px" height="0.75rem"></app-skeleton>
        <app-skeleton width="80px"  height="0.75rem"></app-skeleton>
      </div>
    </div>
  </div>

  <!-- Search -->
  <div class="search-bar stagger-3" *ngIf="!isLoading">
    <span class="material-symbols-outlined search-bar__icon">search</span>
    <input
      class="search-bar__input"
      type="text"
      placeholder="Buscar por cliente, email o servicio..."
      [(ngModel)]="searchQuery"
    />
    <button class="search-bar__clear" *ngIf="searchQuery" (click)="searchQuery = ''">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>

  <!--  Filter tabs  -->
  <div class="filter-tabs stagger-4" *ngIf="!isLoading">
    <button class="filter-tab" [class.filter-tab--active]="activeFilter === 'today'" (click)="activeFilter = 'today'">Hoy</button>
    <button class="filter-tab" [class.filter-tab--active]="activeFilter === 'week'"  (click)="activeFilter = 'week'">Esta semana</button>
    <button class="filter-tab" [class.filter-tab--active]="activeFilter === 'all'"   (click)="activeFilter = 'all'">Todos</button>

    <!-- View toggle (solo visible en pestaña Hoy) -->
    <div class="view-toggle" *ngIf="activeFilter === 'today'">
      <button
        class="view-btn"
        [class.view-btn--active]="viewMode === 'list'"
        (click)="viewMode = 'list'"
        title="Vista lista"
      >
        <span class="material-symbols-outlined">list</span>
      </button>
      <button
        class="view-btn"
        [class.view-btn--active]="viewMode === 'timeline'"
        (click)="viewMode = 'timeline'"
        title="Vista timeline"
      >
        <span class="material-symbols-outlined">view_day</span>
      </button>
    </div>
  </div>

  <!--  Timeline view (solo hoy)  -->
  <div class="timeline stagger-4" *ngIf="activeFilter === 'today' && viewMode === 'timeline'">
    <div
      class="timeline-row"
      *ngFor="let row of todayTimeline"
      [class.timeline-row--occupied]="!!row.appointment"
    >
      <span class="timeline-time">{{ row.time }}</span>
      <div class="timeline-cell">
        <ng-container *ngIf="row.appointment">
          <div class="timeline-apt"
               [class.timeline-apt--confirmed]="row.appointment.status === 'confirmed'"
               [class.timeline-apt--pending]="row.appointment.status === 'pending'">
            <span class="timeline-apt__client">{{ row.appointment.clientName }}</span>
            <span class="timeline-apt__service">{{ row.appointment.serviceType }}</span>
            <span class="timeline-apt__duration">{{ row.appointment.duration }} min</span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!--  Empty state  -->
  <div class="empty-state stagger-4" *ngIf="groupedAppointments.length === 0 && viewMode === 'list'">
    <span class="material-symbols-outlined">event_busy</span>
    <p>No hay turnos para este período.</p>
  </div>

  <!--  Appointment groups  -->
  <div class="apt-groups stagger-4" *ngIf="viewMode === 'list'">
    <div class="apt-group" *ngFor="let group of groupedAppointments">

      <h2 class="group-date">{{ group.label }}</h2>

      <div class="apt-list">
        <div
          class="apt-card"
          *ngFor="let apt of group.items"
          [class.apt-card--cancelled]="apt.status === 'cancelled'"
        >
          <!-- Time + status badge -->
          <div class="apt-card__time-col">
            <span class="apt-time">{{ apt.time }}</span>
            <span class="apt-duration">{{ apt.duration }} min</span>
          </div>

          <!-- Info -->
          <div class="apt-card__info">
            <div class="apt-client">
              <span class="apt-client__name">{{ apt.clientName }}</span>
              <span class="apt-client__email">{{ apt.clientEmail }}</span>
            </div>
            <span class="apt-service">{{ apt.serviceType }}</span>
            <span class="payment-badge" *ngIf="apt.price"
              [class.payment-badge--paid]="apt.paymentStatus === 'paid'"
              [class.payment-badge--unpaid]="apt.paymentStatus !== 'paid'">
              <span class="material-symbols-outlined">{{ apt.paymentStatus === 'paid' ? 'payments' : 'money_off' }}</span>
              {{ apt.paymentStatus === 'paid' ? '$ ' + (apt.price | number:'1.0-0') + ' pagado' : 'Sin pago' }}
            </span>
            <p class="apt-notes" *ngIf="apt.notes">{{ apt.notes }}</p>
          </div>

          <!-- Status + actions -->
          <div class="apt-card__actions">
            <span class="status-chip"
              [class.status-chip--pending]="apt.status === 'pending'"
              [class.status-chip--confirmed]="apt.status === 'confirmed'"
              [class.status-chip--cancelled]="apt.status === 'cancelled'"
            >
              <span class="material-symbols-outlined">
                {{ apt.status === 'pending' ? 'hourglass_top' : apt.status === 'confirmed' ? 'verified' : 'cancel' }}
              </span>
              {{ apt.status === 'pending' ? 'Pendiente' : apt.status === 'confirmed' ? 'Confirmado' : 'Cancelado' }}
            </span>

            <div class="apt-btns" *ngIf="apt.status !== 'cancelled'">
              <button
                class="apt-btn apt-btn--confirm"
                *ngIf="apt.status === 'pending'"
                (click)="confirm(apt)"
                title="Confirmar y descargar .ics"
              >
                <span class="material-symbols-outlined">check</span>
                Confirmar
              </button>

              <button class="apt-btn apt-btn--cal" (click)="addToCalendar(apt)" title="Descargar .ics">
                <span class="material-symbols-outlined">download</span>
              </button>
              <button class="apt-btn apt-btn--gcal" (click)="openGoogle(apt)" title="Google Calendar">
                <span class="material-symbols-outlined">open_in_new</span>
              </button>
              <button class="apt-btn apt-btn--cancel" (click)="cancel(apt.id)" title="Cancelar turno">
                <span class="material-symbols-outlined">close</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
